import React from 'react';
import mapElement from '../helpers/elementMapper.js';
import Button from './Button.js';
import Card from './Card.js';
import Container from './Container.js';
const InfoCardGrid = ({
  headline,
  cards,
  standout = false,
  numberOfColumns = 2
}) => /*#__PURE__*/React.createElement(Container, {
  standout: standout,
  noMargin: true
}, /*#__PURE__*/React.createElement("div", {
  className: "ebds-info-card-grid"
}, /*#__PURE__*/React.createElement("div", {
  className: "ebds-info-card-grid__headline"
}, /*#__PURE__*/React.createElement("h2", null, headline)), /*#__PURE__*/React.createElement("div", {
  className: "ebds-info-card-grid__cards",
  style: numberOfColumns !== 2 ? {
    gridTemplateColumns: `repeat(${numberOfColumns}, 1fr)`
  } : {
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 350px), 1fr))'
  }
}, cards.map(({
  headline,
  elements,
  buttonText,
  buttonSrText,
  buttonAction,
  buttonHref
}, index) => /*#__PURE__*/React.createElement(Card, {
  headline: /*#__PURE__*/React.createElement("h3", null, headline),
  key: index
}, elements.map((element, index) => /*#__PURE__*/React.createElement("div", {
  key: index
}, mapElement(element, index))), buttonText && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
  type: "button",
  mode: "primary",
  state: "normal",
  onClick: buttonAction,
  text: buttonText,
  href: buttonHref,
  srText: buttonSrText
})))))));
export default InfoCardGrid;